import { normalizeBooking } from './normalizeBooking'

const escapeHtml = (value) => String(value || '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')

const row = (label, value) => {
  if (!value) return ''
  return `<tr><th>${escapeHtml(label)}</th><td>${escapeHtml(value)}</td></tr>`
}

const section = (title, rowsHtml) => {
  if (!rowsHtml) return ''
  return `<section><h2>${escapeHtml(title)}</h2><table>${rowsHtml}</table></section>`
}

export function renderBookingPrintHtml (model) {
  const userRows = [
    row('Name', model.user.name),
    row('Email', model.user.email),
    row('Phone', model.user.phone),
    row('Sangat ID', model.user.sangatId)
  ].join('')

  const bookingRows = [
    row('Booking ID', model.bookingId),
    row('Booking date', model.bookingDate),
    row('Booking type', model.moduleLabel),
    row('Status', model.status),
    row(model.moduleLabel === 'Gurudwara Service' ? 'Service' : model.moduleLabel, model.placeName),
    row('Location', model.placeDetail),
    row(model.moduleLabel === 'Gurudwara Service' ? 'Service date' : 'Check-in', model.checkIn),
    row('Check-out', model.checkOut),
    row('Time slot', model.timeSlot),
    row('Guests', model.guests)
  ].join('')

  const roomRows = (model.rooms || []).map((room, index) => row(`Room ${index + 1}`, room)).join('')
  const paymentRows = [
    row('Payment status', model.paymentStatus),
    row('Payment method', model.paymentMethod),
    ...(model.amounts || []).map((amount) => row(amount.label, amount.value)),
    row('Refund amount', model.refund)
  ].join('')
  const extraRows = (model.extras || []).map((item) => row(item.label, item.value)).join('')
  const noteRows = [row('Notes', model.notes), row('Reason', model.cancellation)].join('')
  const documentRows = (model.documents || [])
    .map((document) => row(document.name, `${document.status}${document.files ? ` · ${document.files} file(s)` : ''}`))
    .join('')

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Booking ${escapeHtml(model.bookingId || '')}</title>
  <style>
    @page { size: A4; margin: 14mm; }
    * { box-sizing: border-box; }
    body { margin: 0; color: #1a1a1a; background: #fff; font-family: Arial, Helvetica, sans-serif; font-size: 12px; line-height: 1.45; }
    header { border-bottom: 2px solid #2c0146; margin-bottom: 16px; padding-bottom: 10px; }
    h1 { margin: 0 0 4px; font-size: 22px; color: #2c0146; }
    h2 { margin: 0 0 8px; font-size: 14px; color: #2c0146; }
    .meta { color: #555; }
    section { margin: 0 0 16px; break-inside: avoid; }
    table { width: 100%; border-collapse: collapse; }
    th, td { text-align: left; vertical-align: top; padding: 6px 8px; border-bottom: 1px solid #e6e6e6; }
    th { width: 34%; color: #444; font-weight: 600; background: #faf7fb; }
    @media print {
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  </style>
</head>
<body>
  <header>
    <h1>${escapeHtml(model.moduleLabel)} booking</h1>
    <div class="meta">${escapeHtml(model.bookingId)} · ${escapeHtml(model.status)}</div>
  </header>
  ${section('Booking', bookingRows)}
  ${section('Guest', userRows)}
  ${section('Rooms', roomRows)}
  ${section('Payment', paymentRows)}
  ${section('Additional information', extraRows)}
  ${section('Notes', noteRows)}
  ${section('Documents', documentRows)}
</body>
</html>`
}

export function printBooking (booking, module) {
  const model = normalizeBooking(booking, module)
  const printWindow = window.open('', '_blank', 'width=900,height=700')
  if (!printWindow) {
    throw new Error('Allow pop-ups to print this booking.')
  }
  printWindow.document.open()
  printWindow.document.write(renderBookingPrintHtml(model))
  printWindow.document.close()
  const triggerPrint = () => {
    printWindow.focus()
    printWindow.print()
  }
  if (printWindow.document.readyState === 'complete') {
    setTimeout(triggerPrint, 200)
  } else {
    printWindow.onload = triggerPrint
  }
}
